export default {
  login_account_login: '账号登录',
  login_dynamicCode_login: '动态码登录',
  login_input_username: '请输入用户名',
  login_input_password: '请输入密码',
  login_input_mobilePhone: '请输入手机号码',
  login_input_verifyCode: '请输入短信动态码',
  login_input_code: '请输入验证码',
  login_remember_password: '记住密码',
  login: '登录',
  login_wechat_login: '微信快捷登录',
  login_wechat_scan_login: '使用微信扫一扫登录',
  login_school_verify: '陕西明杉大学统一身份认证',
  login_get_verify_code: '获取动态码',

  login_username_required: '用户名不能为空',
  login_password_required: '密码不能为空',
  login_mobilePhone_required: '手机号码不能为空',
  login_mobilePhone_format: '请输入正确格式的手机号',
  login_verifyCode_required: '动态验证码不能为空',
  login_verifyCode_incorrect: '动态验证码错误',
  login_code_required: '验证码不能为空',
  login_code_incorrect: '验证码错误',
  login_later: '稍后登录',
  login_with_wechat: '微信登录',
  login_with_account: '账号登录',
}